import React from 'react';

const LabelIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24">
    <path d="M22 3v18H8.333L2 12l6.333-9H22zm-6.155 4h-3.69L10 17h1.944l.38-1.809h3.352l.38 1.809H18L15.845 7zm-1.507 1.676l.972 4.75h-2.62l.972-4.75h.676z" />
  </svg>
);

export default LabelIcon;
